import { dew as _compareDew } from "./compare";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  const compare = _compareDew();
  const neq = (a, b, loose) => compare(a, b, loose) !== 0;
  exports = neq;
  return exports;
}